module.exports = __webpack_public_path__ + "static/img/showroom5.848eaad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/showroom5.png
// module id = okIZ
// module chunks = 2